import * as yup from "yup";

export const CreateUserFormValidationSchema = yup.object().shape({
  userEmail: yup
    .string()
    .email("Invalid Email Format")
    .required("Email Address is required"),
  userFirstName: yup.string().required("First Name is required"),
  userLastName: yup.string().required("Last Name is required"),
  userRole: yup
    .string()
    .required("Role is required")
    .notOneOf(["0"], "Role is required"),
  userAddress: yup
    .string()
    .max(100, "Address cannot exceed 100 characters")
    .optional(),
  userCity: yup
    .string()
    .max(100, "City cannot exceed 100 characters")
    .optional(),
  userZipcode: yup
    .string()
    .max(5, "Zip Code cannot exceed 5 digits")
    .optional(),
  userPhone: yup
    .string()
    .max(10, "Work Phone cannot exceed 10 digits")
    .optional(),
  userIsActive: yup.boolean().oneOf([true, false]),
  routinizedHospital: yup.string().optional(),
  routinizedFacility: yup.string().optional(),
  userNotes: yup
    .string()
    .max(500, "Notes cannot exceed 500 characters")
    .optional(),
  createdBy: yup.string().optional(),
  dateCreated: yup.string().optional(),
  updatedBy: yup.string().optional(),
  dateUpdated: yup.string().optional(),
});

export interface RoleData {
  id: number;
  value: string;
}

export interface UserDataFormRequest {
  userEmail?: string;
  userFirstName?: string;
  userLastName?: string;
  userAddress?: string;
  userCity?: string;
  userZipcode?: string;
  userPhone?: string;
  userRole?: string;
  userIsActive?: boolean;
  userNotes?: string;
  routinizedHospital?: string;
  routinizedFacility?: string;
  createdBy?: string;
}
